import Http from 'services/Http';

class Impersonation {
  beginStepUp() {
    return Http.post('/v1/impersonation/step-up/begin');
  }

  start({ targetUserId, password, assertion }) {
    return Http.post('/v1/impersonation', { targetUserId, password, assertion });
  }

  stop() {
    return Http.delete('/v1/impersonation');
  }
}

export default new Impersonation();
